import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useFiltersDefinition } from "@/pages/(app)/returns/hooks/use-filter-definitions";
import { ReturnRequestLogDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { cn } from "@babackapp/ui/lib/utils";
import { LightningBoltIcon } from "@radix-ui/react-icons";
import ActivityContentWrapper from "./activity-content-wrapper";
import ActivityIconWrapper from "./activity-icon-wrapper";
import { ActivityItemHeader } from "./activity-item-header";
import ActivityWrapper from "./activity-wrapper";
import { useActorName } from "@/lib/people/use-shop-people";

type UpdateStatusActivityProps = {
  activity: ReturnRequestLogDto;
};

export default function UpdateStatusActivity({
  activity,
}: UpdateStatusActivityProps) {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();
  const filterDefinitions = useFiltersDefinition({ shop });
  const actorName = useActorName();
  const status = activity.newStatus
    ? filterDefinitions.get("status")?.options.get(activity.newStatus)
    : null;

  const userId = activity.params?.userId;
  const isCustomer = userId === "customer";
  // Members and Baback support alike (BAB-3035).
  const author = userId && !isCustomer ? actorName(userId) : null;

  return (
    <ActivityWrapper>
      <ActivityIconWrapper>
        <LightningBoltIcon className="size-4" />
      </ActivityIconWrapper>
      <ActivityContentWrapper>
        <div className="flex items-center gap-2">
          <ActivityItemHeader title={``} timestamp={activity.date}>
            {status?.value === "created" ? (
              <>
                <span>{t("returnDetail.returnRequestCreated")}</span>
              </>
            ) : (
              <>
                <span>{t("returnDetail.statusUpdated")}</span>
                <span className={cn("font-semibold text-xs", status?.color)}>
                  {status?.label}
                </span>
              </>
            )}
            {isCustomer ? (
              <span className="font-normal">
                {t("returnDetail.byTheClient")}
              </span>
            ) : (
              author && (
                <>
                  <span className="font-normal">{t("returnDetail.by")}</span>
                  <span className="font-semibold">{author}</span>
                </>
              )
            )}
          </ActivityItemHeader>
        </div>
      </ActivityContentWrapper>
    </ActivityWrapper>
  );
}
